/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfigResponse,
  PagedModelConfigResponse,
} from '../models/index';
import {
    ConfigResponseFromJSON,
    ConfigResponseToJSON,
    PagedModelConfigResponseFromJSON,
    PagedModelConfigResponseToJSON,
} from '../models/index';

export interface GetConfigByApiKeyRequest {
    apiKey: string;
}

export interface SearchConfigsByUserIdRequest {
    searchTerm: string;
    page?: number;
    size?: number;
    nameSortDir?: SearchConfigsByUserIdNameSortDirEnum;
}

/**
 * 
 */
export class PublistConfigApi extends runtime.BaseAPI {

    /**
     * Creates request options for getConfigByApiKey without sending the request
     */
    async getConfigByApiKeyRequestOpts(requestParameters: GetConfigByApiKeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['apiKey'] == null) {
            throw new runtime.RequiredError(
                'apiKey',
                'Required parameter "apiKey" was null or undefined when calling getConfigByApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/config/{apiKey}`;
        urlPath = urlPath.replace(`{${"apiKey"}}`, encodeURIComponent(String(requestParameters['apiKey'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getConfigByApiKeyRaw(requestParameters: GetConfigByApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigResponse>> {
        const requestOptions = await this.getConfigByApiKeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigResponseFromJSON(jsonValue));
    }

    /**
     */
    async getConfigByApiKey(requestParameters: GetConfigByApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigResponse> {
        const response = await this.getConfigByApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchConfigsByUserId without sending the request
     */
    async searchConfigsByUserIdRequestOpts(requestParameters: SearchConfigsByUserIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['searchTerm'] == null) {
            throw new runtime.RequiredError(
                'searchTerm',
                'Required parameter "searchTerm" was null or undefined when calling searchConfigsByUserId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchTerm'] != null) {
            queryParameters['searchTerm'] = requestParameters['searchTerm'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['nameSortDir'] != null) {
            queryParameters['nameSortDir'] = requestParameters['nameSortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/config/search`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async searchConfigsByUserIdRaw(requestParameters: SearchConfigsByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelConfigResponse>> {
        const requestOptions = await this.searchConfigsByUserIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelConfigResponseFromJSON(jsonValue));
    }

    /**
     */
    async searchConfigsByUserId(requestParameters: SearchConfigsByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelConfigResponse> {
        const response = await this.searchConfigsByUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const SearchConfigsByUserIdNameSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type SearchConfigsByUserIdNameSortDirEnum = typeof SearchConfigsByUserIdNameSortDirEnum[keyof typeof SearchConfigsByUserIdNameSortDirEnum];
